import { React, classNames } from '@digsup/core-ui';
import { styles } from './Bubbles.scss';

const cx = classNames.bind(styles);

export const Bubbles = () => (
  <div className={cx('l-homepage-hero-bubbles')}>
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-3xs" />
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-2xs" />
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-xs" />
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-sm" />
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-md" />
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-lg" />
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-xl" />
    <div className="l-homepage-hero-bubbles__morph l-homepage-hero-bubbles__morph-2xl" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__small l-homepage-hero-bubbles__4xs" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__small l-homepage-hero-bubbles__3xs" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__small l-homepage-hero-bubbles__2xs" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__small l-homepage-hero-bubbles__xs" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__small l-homepage-hero-bubbles__sm" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__md" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__lg" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__xl" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__2xl" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__3xl" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__4xl" />
    <div className="l-homepage-hero-bubbles__item l-homepage-hero-bubbles__5xl" />
  </div>
);
